/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type LiveManagementListLivecarpForSelectRequest = {
    perPage?: number | null;
    page?: number | null;
    keyword?: string | null;
    sort?: string | null;
    direction?: LiveManagementListLivecarpForSelectRequest.direction | null;
    status?: string | null;
    title?: string | null;
};

export namespace LiveManagementListLivecarpForSelectRequest {

    export enum direction {
        ASC = 'asc',
        DESC = 'desc',
    }


}

